export default "__VITE_ASSET__C92jaIx3__"